{{extend './form_line.art'}}
{{block 'line'}}

{{if data.list}}
{{each data.list item}}
    <input type="radio" name="{{ attr.name }}" value="{{ item.value }}" {{if data.other}} {{@ data.other}}{{/if}} title="{{ item.title }}"{{if item.disabled}} disabled="disabled"{{/if}} {{if item.checked}} checked{{/if}}>
{{/each}}
{{/if}}

{{/block}}